export default {
  auth: {
    back: 'Back to Sign In',
    email: {
      title: 'Learn while having fun!',
      subtitle: 'The best educational content for your kids is just ahead.',
      placeholder: {
        email: 'Enter your PlayKids account email',
        password: 'Enter your password'
      },
      forgotPassword: 'I forgot my password',
      signIn: 'Sign In',
      signInMethodsSeparator: 'OR',
      playphoneRouter: 'Connect with Playphone',
      note: 'Login by phone number: Service only available for applications on mobile devices. Please access the link we have sent you via SMS.',
      signUp: {
        message: 'Not a member yet?',
        CTA: 'Click here to sign up'
      },
      error: {
        email: 'Please enter a valid email.',
        password: 'The password must have at least 6 characters.',
        invalidRequest: 'There is something wrong with your credentials.',
        wrongCredentials:
          "Incorrect password or the email doesn't exist.\nPlease double-check your typing.",
        generic: 'Some error occurred.'
      }
    },
    phone: {
      routerCta: 'Connect with your phone number',
      title: 'Sign in with your phone',
      subtitle:
        'Enter your number with country code. If your carrier needs a PIN, we will ask for it next; otherwise you may sign in right away.',
      continuePhone: 'Continue',
      sendPin: 'Send PIN',
      signIn: 'Sign In',
      otpHint: 'Enter the PIN you received.',
      changeNumber: 'Use a different number',
      backToEmail: 'Sign in with email instead',
      countrySearch: 'Type the country name',
      countryPickerTitle: 'Choose country',
      closeCountryPicker: 'Close',
      placeholder: {
        nationalNumber: 'Phone number',
        pin: 'PIN code'
      },
      error: {
        nationalNumber: 'Enter a valid phone number.',
        pin: 'Enter the PIN we sent you.',
        invalidRequest: 'Check your number and try again.',
        notFound: 'We could not send a PIN to this number.',
        generic: 'Something went wrong. Please try again.'
      }
    },
    viuCallback: {
      signingIn: 'Signing you in…',
      errorTitle: 'We could not complete phone verification',
      backHome: 'Continue to the app',
      invalidHash: 'The verification data could not be read. Please try again or sign in with your phone.',
      somethingWentWrong: 'Something went wrong. Please try again.'
    },
    viuStatus: {
      invalidCredentials: 'Invalid credentials.',
      invalidHash: 'Invalid hash. Verification could not be completed.',
      serverError: 'A server error occurred. Please try again later.',
      requestNotAllowed: 'This request is not allowed.',
      heFailure: 'Header enrichment failed.',
      invalidRequestParameters: 'Invalid request parameters.',
      apiMaintenance: 'This service is temporarily unavailable for maintenance.',
      unknown: 'Something went wrong. Please try again.',
      genericFailure: 'Verification could not be completed.',
      missingData: 'Verification data was incomplete.',
      missingMsisdn: 'Your phone number was missing from the response. Please sign in with your phone.',
      noActiveSubscription:
        'You don’t have an active subscription. Please subscribe or sign in with your phone to continue.',
      invalidIp: 'This IP address is not allowed.',
      requestTimeout: 'The request timed out. Please try again.',
      phoneLoginNoAccount: "We couldn't find a PlayKids account linked to your phone number.",
      phoneLoginNoSubscription: "We couldn't find a PlayKids subscription linked to your phone number.",
      phoneLoginInternalError: 'An internal error occurred.'
    },
    ghanaCallback: {
      signingIn: 'Signing you in…',
      dismiss: 'OK',
      pinRequired:
        'We need a verification code for this number. Tap OK to sign in with your phone and enter the PIN we send you.',
      pinRequiredTitle: 'Verification code required',
      invalidMsisdn: 'We could not read the phone number from the link. Please sign in with your phone instead.',
      genericError: 'Something went wrong. Please try signing in with your phone.'
    },
    apple: {
      signIn: 'Connect with Apple',
      signUp: 'Sign up with Apple'
    },
    facebook: {
      signIn: 'Connect with Facebook',
      signUp: 'Sign up with Facebook'
    },
    playphone: {
      title: 'Connect with Playphone',
      subtitle: 'The best educational content for your kids is just ahead.',
      placeholder: {
        email: 'Your Playphone email address'
      },
      signIn: 'Sign In',
      error: {
        email: 'Please enter a valid email.',
        generic: 'Oops! We couldn’t find an account with this email address.'
      }
    },
    playphoneLastStep: {
      title: 'Final Step',
      subtitle: 'Enter your User ID to login',
      placeholder: {
        email: 'Your Playphone email address'
      },
      signIn: 'Sign In',
      forgotUserId: {
        message: 'Forgot your User ID?',
        CTA: 'Click here.'
      },
      error: {
        email: 'Please enter a valid email.',
        generic: 'Oops! We couldn’t find an account with this email address.'
      }
    },
    forgotPassword: {
      title: 'Forgot your password?',
      subtitle:
        "Don't worry! We will send to your email a link to reset it. :)",
      placeholder: 'Enter your PlayKids account email',
      send: 'Send',
      success:
        'Link sent to <b>{email}</b><br/>Check your email in a few moments.',
      error: {
        email: 'Please enter a valid email',
        generic:
          "Oops! We couldn't send the link to this email, check for typos and try again."
      }
    },
    signUp: {
      hero: {
        title: 'Sign here, have fun wherever you want!',
        content:
          'With your subscription, you can access PlayKids on your smartphone, on your computer or on Smartv. So, fun and knowledge never leave your family.'
      },
      title: 'Sign Up to PlayKids!',
      subtitle: 'The best educational content for your kids is just ahead.',
      placeholder: {
        email: 'Your email address',
        password: 'Create a password'
      },
      signUp: 'Sign Up',
      signUpMethodsSeparator: 'OR',
      methods: {
        facebook:
          'To make it easier, you can create your account using Facebook',
        partner: 'Are you coming for a PlayKids partner? So click here',
        partnerCta: 'Continue via partner'
      },
      partners: {
        title: 'Continue via partner',
        sky: {
          text: 'Continue your registration using your TV SKY data',
          cta: 'Continue via TV sky'
        },
        playphone: {
          text: 'Continue your registration using Internet Service Provider data',
          cta: 'Continue via Internet Service Provider'
        }
      },
      signIn: {
        message: 'Already have an account?',
        CTA: 'Sign In'
      },
      error: {
        email: 'Please enter a valid email.',
        password:
          'The password must be between 8 and 30 characters (letters and numbers).',
        emailAlreadyExists: {
          message:
            'There is already a PlayKids subscription registered with this email.<br/>Do you want to ',
          CTA: 'sign in?'
        },
        invalidRequest: 'There is something wrong with your credentials.',
        generic: 'There was an error.',
        ifoodEmail: 'Please enter a valid iFood email.'
      }
    },
    resetPassword: {
      title: 'Reset your password',
      subtitle: 'A good password should be strong, but also memorable.',
      placeholder: {
        password: 'Enter your new password',
        confirmPassword: 'Re-enter your new password'
      },
      reset: 'Reset Password',
      error: {
        password:
          'The password must have at least 8 characters (letters and numbers).',
        passwordsDontMatch: "The passwords don't match!",
        invalidRequest: 'There is something wrong with your new password.',
        expiredToken: {
          message: 'Your token has expired, try',
          CTA: 're-sending it.'
        },
        generic: 'Some error occurred.'
      }
    },
    emailOnly: {
      title: 'Start now combining<br/>learning and fun',
      subtitle: 'Access your account or create a new one.',
      access: 'Access',
      signInMethodsSeparator: 'or',
      placeholder: {
        email: 'Enter your email'
      },
      playphoneRouter: 'Connect with Playphone',
      error: {
        email: 'Please enter a valid email.',
        invalidRequest: 'There is something wrong with the data provided.',
        generic: 'Some error occurred.'
      }
    },
    passwordOnly: {
      title: 'Already have an account!',
      subtitle: 'We need your password to continue.',
      placeholder: {
        password: 'Enter your password'
      },
      forgotPassword: 'Forgot my password',
      signIn: 'Sign In',
      error: {
        password:
          'The password must have at least 6 characters (letters and numbers).',
        invalidRequest: 'There is something wrong with the data provided.',
        wrongCredentials:
          'Unregistered email or incorrect password.\nPlease try again.',
        generic: 'Some error occurred.'
      }
    }
  },
  common: {
    format: {
      date: 'MM/DD/YYYY',
      dateRaw: 'MMDDYYYY'
    }
  },
  policies: {
    privacy: 'By using Playkids services, you agree with our',
    privacyTitle: 'Privacy Policy',
    privacyLink: 'https://policies.playkids.com/en/privacy',
    tos: 'By using Playkids services, you agree with our',
    tosTitle: 'Terms of use',
    tosLink: 'https://policies.playkids.com/en/tos'
  },
  checkout: {
    registerKid: {
      title: 'For each child, <br />a different experience.',
      description:
        "By filling in the data, you ensure that the content suitable for your child's age group is within reach of the child.",
      form: {
        title: "Cool! Let's create a new profile.",
        description:
          'With the profile, the child will have access to the most suitable content for them!',
        inputName: "Child's Name",
        inputBirthDate: 'Birth date',
        cancelButtonLabel: 'Cancel',
        saveButtonLabel: 'Create Profile',
        updateButtonLabel: 'Save changes',
        successCreateMessage: 'The profile of {name} was created.',
        successUpdateMessage: 'The profile of {name} was updated.',
        successDeleteMessage: 'The profile of {name} was removed.',
        errorCreateMessage:
          'An error has occurred while creating the profile for {name}.',
        errorUpdateMessage:
          'An error has occurred while updating the profile for {name}.',
        errorDeleteMessage:
          'An error has occurred while removing the profile for {name}.'
      },
      list: {
        buttonLabel: 'Create new profile',
        card: {
          name: "Child's Name",
          birthDate: 'Birth date',
          editButton: 'Edit'
        }
      },
      removeModal: {
        title: 'Are you sure you want to delete the profile of',
        cancelButton: 'Cancel',
        removeButton: 'Delete profile'
      }
    },
    planSelector: {
      title: 'The best is just beggining!',
      loading: 'Loading plans...',
      description:
        'Choose your plan and embark on this journey full of fun and knowledge.',
      planBox: {
        month: 'Month',
        months: 'Months',
        priceLabel: {
          month: 'Per month',
          year: 'In 1x'
        },
        priceDetails: 'In this plan, the monthly cost is',
        paymentDetails: 'Billed once.'
      }
    },
    payment: {
      navTabs: {
        itemCard: 'Credt card payment',
        itemCoupon: 'Voucher payment'
      },
      cardTab: {
        title: 'Fill in your details',
        description:
          'We are getting closer and closer to the PlayKids World! Enter your registration data and your credit card.',
        planDetails:
          'You will have a month of trial to explore the PlayKids World. You will only be charged {planPrice} after the end of the 30 days. You can cancel before the end of the test.',
        form: {
          personalSection: {
            title: 'Personal Data',
            documentLabel: 'CPF',
            addressLabel: 'Address',
            addressZipCodeLabel: 'CEP',
            addressDistrictLabel: 'Neighborhood',
            addressNumberLabel: 'Number',
            addressComplementLabel: 'Complement',
            addressCityLabel: 'City',
            addressStateLabel: 'State'
          },
          paymentSection: {
            title: 'Payment data',
            documentLabel: 'CPF',
            emailLabel: 'E-mail',
            cardNumberLabel: 'Credit card number',
            cardHolderNameLabel: "Cardholder's name",
            cardExpirationMonthLabel: 'Month',
            cardExpirationYearLabel: 'Year'
          }
        }
      },
      couponTab: {
        title: 'Fill in the data of your voucher',
        description:
          'We are getting closer and closer to the PlayKids World! Insert your coupon to complete the registration.',
        form: {
          couponLabel: 'Enter your voucher',
          couponInput: 'Discount voucher'
        }
      }
    },
    checkoutPaymentSucceeded: {
      title: 'Hi, how good it is to have you here with us.',
      subtitle: 'First of all, your subscription is confirmed!',
      description:
        "Now children will be able to enjoy the PlayKids universe by accessing all our content via smartphones, tablets, computers and even Smart TVs! <br /><strong>It's PlayKids Everywhere!</strong><br /> To access PlayKids on other devices, just look for the APP in your device store and login with your PlayKids account!",
      finish: 'Start'
    }
  },
  account: {
    credentials: {
      title: 'Account details',
      facebook: {
        title: 'Your login is via Facebook',
        text: 'We will never post anything to your account or send messages to your contacts'
      }
    },
    status: {
      subscription: {
        type: {
          title: 'Subscription type',
          values: {
            SEMESTERLY: 'Biannual',
            YEARLY: 'Annual'
          }
        },
        status: {
          title: 'Subscription status',
          values: {
            ACTIVE: 'Active'
          }
        },
        expiration: {
          title: 'Expiration'
        },
        cancelCta: 'Cancel subscription'
      }
    },
    payments: {
      title: 'Payments',
      datePayment: 'Your next charge will be: ',
      dateCancellation: 'Subscription will expire in: ',
      howToChange: 'How to change the subscription'
    },
    changeEmail: {
      title: 'Change email',
      emailPlaceholder: 'Enter your new email address',
      passwordPlaceholder: 'enter your current password',
      errors: {
        403: 'Incorrect password',
        409: 'This email is already in use',
        same: 'This email is already used by you'
      },
      cancel: 'Cancel',
      cta: 'Change email',
      success: 'Email changed'
    },
    changePassword: {
      title: 'Change password',
      placeholders: {
        current: 'Enter your current password',
        new: 'Enter your new password (min, 8 characters)',
        confirm: 'Confirm your new password'
      },
      errors: {
        403: 'Current password is incorrect',
        generic: 'Oops, we could not register your new password'
      },
      success: 'Password changed successfully!',
      cta: 'Change password'
    },
    cancelSubscription: {
      title: 'Are you sure you want to cancel your subscription?',
      textDate:
        'By canceling now you will have access to the content until [DATE]. You can resubscribe at any time.',
      textFooter: 'PlayKids will always be a safe and educational environment.',
      errorLine: 'We were unable to cancel your subscription.',
      cancel: 'Back',
      cta: 'Cancel subscription',
      modalCta: 'I want to cancel',
      success: {
        title: 'Cancellation successful',
        text1:
          'We hope your little one learned and had a lot of fun while we were together.',
        text2:
          'Finally, could you take a quick survey to help us out?',
        formCta: 'Answer survey'
      }
    }
  },
  misc: {
    backButtonText: 'Back to browse',
    developmentTagsTitle: 'Educational Development',
    season: '{n} Season | {n} Seasons',
    episodes: 'Episodes',
    ageAdvise:
      'Every show in PlayKids is appropriate for all ages, but some themes are best apprehended in specific stages of the child’s development.',
    termsOfUse: {
      text: 'Terms of Use',
      url: 'https://cdn.pkds.it/policy/ios/tos-en.html'
    },
    privacyPolicy: {
      text: 'Privacy Policy',
      url: 'https://cdn.pkds.it/policy/ios/privacy-en.html'
    },
    creditCard: {
      securityCodeLabel: 'Security <br />code',
      expiration: {
        month: 'MM',
        year: 'AAAA'
      }
    }
  },
  inactive: {
    message:
      "Apparently, you don't have an active PlayKids Subscription, so you can't access our content <span>:(</span>"
  },
  downloadAppBanner: {
    title: 'PlayKids App',
    text: 'Videos, books and games to learn while having fun!',
    CTA: 'Get'
  },
  demo: {
    badge: 'demo version',
    dialog: {
      text: 'Want full access to the content?',
      CTA: 'Subscribe now!'
    }
  },
  header: {
    message: 'Already have an account?',
    button: 'Sign In'
  },
  menu: {
    account: 'Account',
    support: 'Support',
    logout: 'Logout'
  },
  footer: {
    title: 'Do you have questions?',
    links: {
      questions: {
        title: 'Help Center',
        url: 'https://help.playkids.com'
      },
      termsOfUse: {
        title: 'Terms of Use',
        url: 'https://policies.playkids.com/en/tos'
      },
      privacyPolicy: {
        title: 'Privacy Policy',
        url: 'https://policies.playkids.com/en/privacy'
      },
      informationSecurityPolicy: {
        title: 'Information Security Policy',
        url: 'https://policies.playkids.com/en/security'
      },
      cookiePolicy: {
        title: 'Cookie Policy',
        url: 'https://policies.playkids.com/en/cookie'
      }
    }
  },
  partnerships: {
    form: {
      authenticated: {
        title: 'Enter your account details to finish creating your login',
        inputEmail: 'Enter your PlayKids account email',
        inputCode: 'Enter your customer code',
        cancelButton: 'Cancel',
        confirmButton: 'Confirm'
      },
      signIn: {
        inputEmail: 'Enter your PlayKids account email',
        inputPassword: 'Enter your access password',
        cta: 'Sign In'
      },
      signInOption: {
        title: 'Already have a PlayKids account?',
        cta: 'Click here to enter'
      },
      signUpOption: {
        title: "Don't have a PlayKids account?",
        cta: 'Sign Up'
      },
      signUp: {
        inputEmail: 'Enter the email for your PlayKids account',
        inputConfirmEmail: 'Confirm your PlayKids account email',
        inputPassword: 'Create your access password',
        inputPasswordHint:
          'The password must be between 8 and 30 characters (letters and numbers).',
        cta: 'Create PlayKids Account'
      },
      success: {
        title: 'Nice! Your registration was completed successfully!',
        description:
          'Now children will be able to enjoy the PlayKids universe by accessing all our content via smartphones, tablets, computers and even Smart TVs!',
        subtitle: "It's PlayKids Everywhere!",
        stores:
          'To access PlayKids on other devices, just look for the APP in your device store and login with your PlayKids account!',
        signInTitle: "Nice! Now let's link your PlayKids account.",
        signInAuthenticatedTitle:
          'Great! Your account has been successfully signed in.',
        authenticatedDescription:
          'To finish redeeming your benefit click the redemption button or cancel not to redeem now.',
        signInDescription:
          'Inform the email and password you already use to access PlayKids applications',
        signUpAuthenticatedTitle:
          'Great! Your account has been successfully created.',
        signUpTitle: "Nice! Let's create a PlayKids account.",
        signUpDescription:
          'First we need you to tell us the email and password you will use to access PlayKids apps'
      },
      errors: {
        inputEmail: 'Please enter a valid email.',
        inputConfirmEmail: 'Emails do not match!',
        inputPassword: 'Please enter a valid password.',
        inputCode: 'Enter a valid customer code.',
        wrongCredentials:
          'Email not registered or password incorrect.<br />Please try again.',
        emailAlreadyExists:
          "We've already found a PlayKids account registered in this email.",
        generic:
          "Oops! Something didn't work as we expected while validating your registration.<br />Please try again later."
      },
      playhub: {
        validation: {
          internetProvider: 'Enter your Internet Service Provider name',
          inputUser: 'Enter your username',
          inputPassword: 'Enter the password provided by your Provider',
          headerTitle: "Let's validate your account!",
          headerDescription:
            'Fill out the form below with your Internet Service Provider information to validate the creation of your account.',
          validationButton: 'Validate'
        }
      }
    },
    playhub: {
      validation: {
        haederTitle: "Let's validate your PlayHub account!",
        headerDescription:
          'Fill out the form below with your PlayHub information to validate the creation of your account.',
        validationButton: 'Validate'
      }
    }
  },
  tags: {
    body_expression: 'Body Expression',
    directions: 'Directions',
    spatial_orientation: 'Spatial Orientation',
    temporal_orientation: 'Temporal Orientation',
    sports_and_activities: 'Sports and Activities',
    drawing: 'Drawing',
    painting: 'Painting',
    writing: 'Writing',
    handmade_activities: 'Handmade Activities',
    balance: 'Balance',
    vocabulary_and_words: 'Vocabulary and Words',
    image_interpretation: 'Image Interpretation',
    phonemes_and_alphabet: 'Phonemes and Alphabet',
    colors: 'Colors',
    sounds_and_sound_sources: 'Sounds and Sound Sources',
    artistic_language: 'Artistic Language',
    reading_and_fluency: 'Reading and Fluency',
    grammar: 'Grammar',
    genres_and_textual_types: 'Genres and Textual Types',
    fantasy_and_imagination: 'Fantasy and Imagination',
    musical_scale_and_styles: 'Musical Scale and Styles',
    musical_instruments: 'Musical Instruments',
    artistic_expression: 'Artistic Expression',
    language: 'Language',
    songs_and_rhymes: 'Songs and Rhymes',
    symbols: 'Symbols',
    numbers: 'Numbers',
    shapes: 'Shapes',
    counting: 'Counting',
    sorting: 'Sorting',
    measurement: 'Measurement',
    comparison: 'Comparison',
    capacity: 'Capacity',
    series_and_sequences: 'Series and Sequences',
    values: 'Values',
    charts_and_tables: 'Charts and Tables',
    quantities: 'Quantities',
    finance: 'Finance',
    operations: 'Operations',
    biology_and_life: 'Biology and Life',
    fauna_and_flora: 'Fauna and Flora',
    geography_and_phenomena: 'Geography and Phenomena',
    outer_space: 'Outer Space',
    physics: 'Physics',
    chemistry: 'Chemistry',
    body_and_health: 'Body and Health',
    foods: 'Foods',
    senses_and_sensations: 'Senses and Sensations',
    auditory_attention: 'Auditory Attention',
    temporal_perception: 'Temporal Perception',
    spatial_perception: 'Spatial Perception',
    shape_perception: 'Shape Perception',
    memory: 'Memory',
    attention: 'Attention',
    concentration: 'Concentration',
    problem_solving: 'Problem Solving',
    logic: 'Logic',
    empirical_knowledge: 'Empirical Knowledge',
    decision_making: 'Decision making',
    games_and_toys: 'Games and Toys',
    family: 'Family',
    citizenship_and_ethics: 'Citizenship and Ethics',
    holidays_and_celebrations: 'Holidays and Celebrations',
    cultures_and_mores: 'Cultures and Mores',
    work_and_occupation: 'Work and Occupation',
    history: 'History',
    places_and_landscapes: 'Places and Landscapes',
    transport: 'Transport',
    media: 'Media',
    objects_and_transformations: 'Objects and Transformations',
    sustainability: 'Sustainability',
    tech: 'Tech',
    safety: 'Safety',
    collectivity: 'Collectivity',
    empathy: 'Empathy',
    social_participation: 'Social Participation',
    respect_and_tolerance: 'Respect and Tolerance',
    equality: 'Equality',
    justice: 'Justice',
    relationships: 'Relationships',
    duties_and_rights: 'Duties and Rights',
    physical_characteristics: 'Physical Characteristics',
    feelings_and_emotions: 'Feelings and Emotions',
    fear_and_frustration: 'Fear and Frustration',
    habits_and_routine: 'Habits and Routine',
    clothing: 'Clothing',
    hygiene_and_welfare: 'Hygiene and Welfare',
    behavior: 'Behavior',
    needs: 'Needs',
    genres: 'Genres',
    protagonism: 'Protagonism',
    creativity: 'Creativity',
    autonomy: 'Autonomy',
    self_control_and_resilience: 'Self Control and Resilience',
    graphic_language: 'Graphic Language',
    images_and_shapes: 'Images and Shapes',
    idioms: 'Idioms',
    food_and_alimentation: 'Food and Alimentation',
    chemistry_and_physics: 'Chemistry and Physics',
    environment: 'Environment',
    people_and_family: 'People and Family',
    team_work: 'Team work',
    food: 'Food',
    self_control: 'Self Control',
    biology: 'Biology',
    flora: 'Flora',
    animals: 'Animals',
    how_stuff_is_made: 'How stuff is made',
    how_stuff_works: 'How stuff works',
    resilience: 'Resilience',
    natural_phenomena: 'Natural Phenomena',
    places_and_landmarks: 'Places and Landmarks',
    human_body: 'Human Body',
    geography: 'Geography',
    digital_citizenship: 'Digital Citizenship',
    digital_literacy: 'Digital Literacy',
    cancel: 'Cancel'
  }
}
